// TODO: serial news
export enum NewsFrequency {
  EVERY_WEEK = 'every_week',
  EVERY_MONTH = 'every_month',
  EVERY_QUARTER = 'every_quarter',
  EVERY_YEAR = 'every_year'
}

export function getNewsFrequencyString(enumValue: NewsFrequency | undefined): string {
  switch (enumValue) {
    case NewsFrequency.EVERY_WEEK:
      return 'Co tydzień';
    case NewsFrequency.EVERY_QUARTER:
      return 'Co kwartał';
    case NewsFrequency.EVERY_YEAR:
      return 'Co rok';
    case NewsFrequency.EVERY_MONTH:
    default:
      return 'Co miesiąc';
  }
}
